import { apiClient } from './api';

export interface SubscriptionInfo {
  brandId: string;
  brandName: string;
  plan: string | null;
  status: string | null;
  currentPeriodEnd: string | null;
  hasBillingAccount: boolean;
}

export interface ConnectStatus {
  connected: boolean;
  accountId?: string;
  chargesEnabled: boolean;
  payoutsEnabled: boolean;
  detailsSubmitted: boolean;
}

export const paymentApi = {
  /** Whether Stripe is configured on the server at all (to hide payment UI). */
  config: () => apiClient.get<{ configured: boolean }>('/payments/config').then((r) => r.data),

  // ── SaaS subscriptions (Billing) ──
  billingSubscription: (brandId: string) =>
    apiClient.get<SubscriptionInfo>('/payments/billing/subscription', { params: { brandId } }).then((r) => r.data),
  billingCheckout: (brandId: string, plan: string) =>
    apiClient.post<{ url: string }>('/payments/billing/checkout', { brandId, plan }).then((r) => r.data),
  billingPortal: (brandId: string) =>
    apiClient.post<{ url: string }>('/payments/billing/portal', { brandId }).then((r) => r.data),

  // ── Salon payments (Connect) ──
  connectStatus: (salonId: string) =>
    apiClient.get<ConnectStatus>('/payments/connect/status', { params: { salonId } }).then((r) => r.data),
  connectOnboard: (salonId: string) =>
    apiClient.post<{ url: string }>('/payments/connect/onboard', { salonId }).then((r) => r.data),

  // ── Booking payment (public / client) ──
  bookingCheckout: (bookingId: string) =>
    apiClient.post<{ url: string }>(`/payments/booking/${bookingId}/checkout`).then((r) => r.data),
};
